import { z } from 'zod';
import { isValidPhoneNumber } from 'libphonenumber-js';

type InquirySchemaMesasges = {
  RequiredMessage: string;
  MailMessage: string;
  PhoneNumberMessage: string;
  KanaMessage: string;
  MaxLengthMessage: (max: number) => string;
};

// 全角カタカナの正規表現
const ZennkakuKanaRegex = /^[ァ-ヴー]+$/;

export const InquirySchema = (messages: InquirySchemaMesasges) =>
  z.object({
    firstName: z
      .string()
      .max(100, messages.MaxLengthMessage(100))
      .optional()
      .or(z.literal(''))
      .nullable(),
    lastName: z
      .string()
      .max(100, messages.MaxLengthMessage(100))
      .optional()
      .or(z.literal(''))
      .nullable(),
    firstNameKana: z
      .string()
      .regex(ZennkakuKanaRegex, messages.KanaMessage)
      .max(100, messages.MaxLengthMessage(100))
      .optional()
      .or(z.literal(''))
      .nullable(),
    lastNameKana: z
      .string()
      .regex(ZennkakuKanaRegex, messages.KanaMessage)
      .max(100, messages.MaxLengthMessage(100))
      .optional()
      .or(z.literal(''))
      .nullable(),
    phoneNumber: z
      .string({
        required_error: messages.RequiredMessage,
        invalid_type_error: messages.RequiredMessage,
      })
      .min(1, messages.RequiredMessage)
      .refine(isValidPhoneNumber, {
        message: messages.PhoneNumberMessage,
      }),
    mail: z
      .string({
        required_error: messages.RequiredMessage,
      })
      .min(1, messages.RequiredMessage)
      .max(100, messages.MaxLengthMessage(100))
      .email(messages.MailMessage),
    inquiryType: z.enum(['0', '1', '2', '3']),
    inquiry: z.string().min(1, messages.RequiredMessage),
  });
export type InquirySchemaType = z.infer<ReturnType<typeof InquirySchema>>;
